/*
*
* File JS per la Page Festival
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroFullSlider from 'components/hero-full-slider/hero-full-slider';
import cardGuest from 'components/card-guest/card-guest';
import cardGuestFeatured from 'components/card-guest-featured/card-guest-featured';

// COMPONENTI CUSTOM BLOCKS
import blockText from 'components/block-text/block-text';
import blockImage from 'components/block-image/block-image';
import scrollBanner from 'components/scroll-banner/scroll-banner';
import blockGallery from 'components/block-gallery/block-gallery';
import blockAltTextImage from 'components/block-alt-text-image/block-alt-text-image';
import blockEmbed from 'imComponents/block-embed/block-embed';
import blockVideo from 'imComponents/block-video/block-video';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './page-festival.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

heroFullSlider();
scrollBanner();
blockVideo();

//--------------------------------------------------------------------//